import {Filter} from '../filter';
import {KeywordParameter} from '../parameter';
import {Url, Controller} from '../controller';
import {vector} from '@/embeddings/vector';
import {clamp} from '../helpers';

export class KeywordFilter extends Filter {
  $_params = [new KeywordParameter('Keyword')];

  static $_title = 'Keyword';
  static $_description = 'Rank by keyword and related';

  get $_keyword() {
    return this.$_params[0];
  }

  $_score(url: Url, controller: Controller) {
    const kw = this.$_keyword.$_value;
    if (kw == null) return null;
    const idx = controller.$_wordMap[kw];
    if (idx == null) return null;
    let total = 0;
    let max = 0;

    url.iterate(this, word => {
      total += vector.cosSim(
        controller.$_dataset.points[idx].vector,
        controller.$_dataset.points[word.index].vector
      );
      max++;
    });

    return clamp(total / max, -1, 1);
  }
}

export class RegularExpressionWordFilter extends Filter {
  $_params = [new KeywordParameter('Regular expression word')];

  static $_title = 'Regular expression word';
  static $_description = 'Filter words by regular expression';

  get $_re() {
    return this.$_params[0];
  }

  $_score(url: Url) {
    const val = this.$_re.$_value;
    if (val == null) return null;
    const re = new RegExp(val);

    let total = 0;
    let max = 0;

    url.iterate(this, word => {
      if (re.test(word.label)) {
        total++;
      } else {
        total--;
      }
      max++;
    });

    return clamp(total / max, -1, 1);
  }
}

export class RegularExpressionOverallFilter extends Filter {
  $_params = [new KeywordParameter('Regular expression overall')];

  static $_title = 'Regular expression overall';
  static $_description = 'Filter domain by regular expression';

  $_score(url: Url) {
    const val = this.$_params[0].$_value;
    if (val == null) return null;
    const re = new RegExp(val);

    const text = url.$_words.map(w => w.label).join('');
    if (re.test(text)) return 1;
    return -1;
  }
}
